<ngx-monaco-editor [options]="editorOptions" class="json-editor" [(ngModel)]="value" (onInit)="editorInit($event)">
    style="height: 300px; width: 100%">
</ngx-monaco-editor>